"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditLogEntryTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const field_change_1 = require("./field-change");
exports.AuditLogEntryTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    timestamp: typebox_1.Type.String(),
    entityID: typebox_1.Type.String(),
    entityType: typebox_1.Type.String(),
    userID: typebox_1.Type.String(),
    haulerID: typebox_1.Type.String(),
    action: typebox_1.Type.String(),
    changes: typebox_1.Type.Array(field_change_1.FieldChange),
});
//# sourceMappingURL=audit-log-entry-transport.js.map